import { TITLE_MIN, TITLE_MAX, isPublishableTitle } from './title_limits';

describe('isPublishableTitle', () => {
  it('14字・61字は公開できない', () => {
    expect(isPublishableTitle('あ'.repeat(14))).toBe(false);
    expect(isPublishableTitle('あ'.repeat(61))).toBe(false);
  });

  it('15字・60字は公開できる', () => {
    expect(isPublishableTitle('あ'.repeat(15))).toBe(true);
    expect(isPublishableTitle('あ'.repeat(60))).toBe(true);
  });

  it('空は公開できない', () => {
    expect(isPublishableTitle('')).toBe(false);
    expect(isPublishableTitle(undefined)).toBe(false);
  });

  it('上限は入力欄の maxLength と同じ60、下限は15', () => {
    expect(TITLE_MIN).toBe(15);
    expect(TITLE_MAX).toBe(60);
  });
});
